import React, { useState, useEffect } from 'react';

const PageBanner = ({ title, subtitle, breadcrumbs = [], backgroundImage, fallback, loading = false }) => {
  const [currentSrc, setCurrentSrc] = useState(backgroundImage || fallback);

  useEffect(() => {
    setCurrentSrc(backgroundImage || fallback);
  }, [backgroundImage, fallback]);

  const handleError = (e) => {
    if (backgroundImage && !e.currentTarget.dataset.triedAlt) {
      e.currentTarget.dataset.triedAlt = '1';
      if (backgroundImage.includes('/admin/public/uploads/')) {
        setCurrentSrc(backgroundImage.replace('/admin/public/uploads/', '/admin/uploads/'));
      } else if (backgroundImage.includes('/admin/uploads/')) {
        setCurrentSrc(backgroundImage.replace('/admin/uploads/', '/admin/public/uploads/'));
      }
    } else if (fallback && currentSrc !== fallback) {
      setCurrentSrc(fallback);
    }
  };

  return (
    <div className="page-hero">
      {loading ? null : <img src={currentSrc} alt={title || ''} className="page-hero-img" onError={handleError} />}
    </div>
  );
};

export default PageBanner;
